import { createAsyncSelectors } from '@lib/selectors';
import { importsActions } from '@sonar-software/sonar-imports';
import { useAction, useOnMount, useSonarSelector } from '@hooks';
const selectors = createAsyncSelectors((state) => state.imports.latest.counts);
export function useLatestImportCounts(refresh = false) {
    const getImportCounts = useAction(importsActions.requestGetImportsLatestCounts);
    const importCounts = useSonarSelector(selectors.data);
    useOnMount(() => {
        if (refresh) {
            getImportCounts();
        }
    });
    return importCounts !== null && importCounts !== void 0 ? importCounts : {};
}
useLatestImportCounts.selectors = selectors;
